export interface OverflowMeasurement {
  hiddenItems: string[];
  hiddenItemsTooltip: string;
  hiddenItemCount: number;
  visibleCount: number;
  ellipsisOffsetLeft: string;
}

export function calcChipOverflow(chipList: NodeList): OverflowMeasurement[] {
  const chips = [];
  const measurements: OverflowMeasurement[] = [];

  chipList.forEach((element) => {
    chips.push(element);
  });
  chips.forEach((chipListElement, i) => {
    const chipWrapper: Partial<HTMLElement> = chipListElement.children[0];
    let lastVisibleChip: HTMLElement;
    let lastChipTopPos = 0;
    let restAreHidden = false;
    const hiddenItems: string[] = [];
    let visibleCount = 0;
    for (const child of Object.values(chipWrapper.children)) {
      const chip = child as HTMLElement;
      if (chip.classList && chip.classList.contains('mat-mdc-chip')) {
        const chipRect = chip.getBoundingClientRect();
        if (!lastChipTopPos || (!restAreHidden && lastChipTopPos === chipRect.top)) {
          lastChipTopPos = chipRect.top;
          lastVisibleChip = chip;
          visibleCount++;
        } else {
          hiddenItems.push(chip.innerText);
          restAreHidden = true;
        }
      }
    }
    let ellipsisOffsetLeft = '';
    if (lastVisibleChip) {
      if (chipListElement.nextElementSibling?.classList.contains('chip-ellipsis')) {
        ellipsisOffsetLeft = lastVisibleChip.offsetLeft + lastVisibleChip.offsetWidth + 'px';
      }
    }
    measurements[i] = {
      hiddenItems,
      hiddenItemsTooltip: hiddenItems.join(',\n'),
      hiddenItemCount: hiddenItems.length,
      visibleCount,
      ellipsisOffsetLeft,
    };
  });

  return measurements;
}
